var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 712,
    height: 2,
    viewBox: "0 0 712 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H712",
    stroke: "#E2E3E5",
    strokeWidth: 2,
    strokeMiterlimit: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDivider);
export default __webpack_public_path__ + "static/media/chat-divider.a373c8651637d6fdefb2811555ae3f10.svg";
export { ForwardRef as ReactComponent };